import { Status } from '../models/Common/CommonModels';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useZelosCommonStore: any = defineStore('zelosCommonStore', () => {
  const status = ref<Status>(sessionStorage.getItem('zelos.status') != null ? JSON.parse(sessionStorage.getItem('zelos.status')!) : new Status());

  function setStatus(newStatus: Status) {
    status.value = newStatus;
    sessionStorage.setItem('zelos.status', JSON.stringify(status.value));
  }

  return {
    status,
    setStatus,
  };
});
